// Încarcă articolele din src/content/articles/*.md la build (Vite glob).
// Frontmatter simplu `--- ... ---` parsat fără gray-matter (evită Buffer în browser).
const files = import.meta.glob('../content/articles/*.md', { query: '?raw', import: 'default', eager: true })

function parse(raw) {
  const m = raw.match(/^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/)
  if (!m) return { meta: {}, body: raw }
  const meta = {}
  for (const line of m[1].split('\n')) {
    const i = line.indexOf(':')
    if (i > 0) meta[line.slice(0, i).trim()] = line.slice(i + 1).trim().replace(/^["']|["']$/g, '')
  }
  return { meta, body: m[2] }
}

export const ARTICLES = Object.entries(files)
  .map(([path, raw]) => {
    const slug = path.split('/').pop().replace(/\.md$/, '')
    const { meta, body } = parse(raw)
    return { slug, ...meta, body }
  })
  .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')))

export const articleBySlug = Object.fromEntries(ARTICLES.map((a) => [a.slug, a]))

export const articlesByIndustry = (industry) =>
  ARTICLES.filter((a) => String(a.industry || '').toLowerCase() === String(industry || '').toLowerCase())
